<template>
  <v-dialog v-model="dialog" attach :max-width="width" @click:outside="choose(false)">
    <v-card tile>
      <v-toolbar v-if="title" dark :color="color" dense flat>
        <v-icon v-if="icon" left>{{ icon }}</v-icon>
        <v-toolbar-title class="white--text" v-text="title"/>
      </v-toolbar>
      <v-card-text class="body-1 text-body-1 py-3" v-html="message"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          text
          v-if="buttonFalseText"
          :color="buttonFalseColor"
          @click="choose(false)"
        >
          {{ buttonFalseText }}
        </v-btn>
        <v-btn
          v-if="buttonTrueText"
          :color="buttonTrueColor"
          @click="choose(true)"
        >
          {{ buttonTrueText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable indent */

  import i18n from '@/i18n'

  export default {
    name: 'Confirm',
    props: {
      buttonTrueText: {
        type: String,
        default: function () {
          return i18n.t('Dialogs.Confirm.buttonTrueText')
        }
      },
      buttonFalseText: {
        type: String,
        default: function () {
          return i18n.t('Dialogs.Confirm.buttonFalseText')
        }
      },
      buttonTrueColor: {
        type: String,
        default: 'primary'
      },
      buttonFalseColor: {
        type: String,
        default: 'grey'
      },
      color: {
        type: String,
        default: 'primary'
      },
      icon: {
        type: String,
        default: 'mdi-alert'
      },
      message: {
        type: String,
        required: true
      },
      persistent: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
      width: {
        type: Number,
        default: 450
      }
    },
    data () {
      return {
        dialog: false
      }
    },
    watch: {
      dialog: function (value) {
        if (value === false) {
          this.resolve(value)
        }
      }
    },
    methods: {
      show: function () {
        this.dialog = true
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      choose (value) {
        this.resolve(value)
      }
    }
  }
</script>
